import {Box, HBox} from '../../../components/core/view';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import HourGlass from '@buncha/components/core/icon/HourGlass';
import If from '@buncha/components/conditional/If';
import {PSmallText} from '../../../components/core/text';
import React from 'react';
import {quantityPillStyles} from './styles';

interface OrganicPillProps {
  orderItemUnit: string;
}

const QuantityPill = (props: OrganicPillProps) => {
  const theme = useColorThemeType('main');
  const {orderItemUnit} = props;
  const muliFont = useFontTheme('muli');

  return (
    <If condition={orderItemUnit}>
      <Box style={quantityPillStyles.containerBox}>
        <HBox
          style={[
            quantityPillStyles.infoBox,
            {
              backgroundColor: theme?.background.yellow[200],
            },
          ]}>
          <HourGlass
            fill={theme?.background.blue[300]}
            height={12}
            width={12}
            viewBox="0 -7 15 25"
          />
          <PSmallText
            style={[
              {
                color: theme?.text.blue[300],
                fontFamily: muliFont[700].normal,
              },
            ]}>
            {orderItemUnit}
          </PSmallText>
        </HBox>
      </Box>
    </If>
  );
};

export default React.memo(QuantityPill);
